import React from 'react';
import ResumeDownload from './ResumeDownload';

export interface ExperienceProps {}

const Experience: React.FC<ExperienceProps> = (props) => {
    return (
        <div className="site-page-content">
            <ResumeDownload />
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>Authorized Dealerships of Güral Porselen</h1>
                        <a
                            rel="noreferrer"
                            target="_blank"
                            href={'https://www.guralporselen.com/'}
                        >
                            <h4>guralporselen.com</h4>
                        </a>
                    </div>
                    <div style={styles.headerRow}>
                        <h3>Product Manager</h3>
                        <b>
                            <p>Apr 2022 - Jan 2023</p>
                        </b>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Spearheaded the end-to-end digital transformation and P&L management for the e-commerce division. Orchestrated product strategy across major marketplaces (Trendyol, Amazon, Hepsiburada), directly driving a 39% increase in total online revenue during tenure.
                </p>
                <br />
                <ul>
                    <li>
                        <p>
                            Spearheaded digital transformation and product lifecycle management across major marketplaces (Trendyol,
Amazon, Hepsiburada).

                        </p>
                    </li>
                    <li>
                        <p>
                            Drove a 39% year-over-year revenue increase by implementing data-driven dynamic pricing strategies and
optimizing listing SEO.
                        </p>
                    </li>
                    <li>
                        <p>
                            Leveraged predictive analytics to forecast inventory demand, minimizing stockouts during peak seasons and
optimizing supply chain workflows.
                        </p>
                    </li>
                    <li>
                        <p>
                            Analyzed customer behavior data to improve conversion rates (CR) and enhance the digital user experience.
                        </p>
                    </li>
                </ul>
            </div>
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>GGG Petrolleri</h1>
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href={'https://www.gggpetrolleri.com/'}
                        >
                            <h4>gggpetrolleri.com/</h4>
                        </a>
                    </div>
                    <div style={styles.headerRow}>
                        <h3>Field Operations</h3>
                        <b>
                            <p>Jan 2023 - May 2023</p>
                        </b>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Led on-site operational audits and process standardization initiatives across the station network to ensure regulatory compliance and service excellence.
                </p>
                <br />
                <ul>
                    <li>
                        <p>
                            Conducted operational data analysis and process audits to enhance service efficiency and regulatory compliance
across the station network.
                        </p>
                    </li>
                    <li>
                        <p>
                            Designed actionable reporting dashboards for HQ, supporting strategic resource allocation decisions and
standardizing field operations
                        </p>
                    </li>
                </ul>
            </div>
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>Keywords Studios</h1>
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href={'https://www.keywordsstudios.com/'}
                        >
                            <h4>keywordsstudios.com</h4>
                        </a>
                    </div>
                    <div style={styles.headerRow}>
                        <h3>
Localization Project Lead</h3>
                        <b>
                            <p>Jun 2022, Present, Remote</p>
                        </b>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Directed complex localization lifecycles for AAA gaming titles (e.g., The Callisto Protocol, Rainbow Six Siege), serving as the strategic link between global development studios and local production teams.
                </p>
                <br />
                            <div className="text-block">
                <ul>
                    <li>
                        <p>
                            Directing end-to-end localization lifecycles for high-profile AAA gaming titles (e.g., The Callisto Protocol), acting as
the strategic bridge between global development studios and local production teams.
                        </p>
                    </li>
                    <li>
                        <p>
Managing a remote cross-functional team of 8+ voice talents and engineers, ensuring 100% adherence to strict
project timelines and budget constraints                        </p>
                    </li>
                                        <li>
                        <p>
MMitigating operational risks and streamlining audio production workflows to ensure seamless simultaneous global
launches.
</p>
                    </li>

                </ul>
            </div>
            </div>
        </div>
    );
};

const styles: StyleSheetCSS = {
    header: {
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
    },
    skillRow: {
        flex: 1,
        justifyContent: 'space-between',
    },
    skillName: {
        minWidth: 56,
    },
    skill: {
        flex: 1,
        padding: 8,
        alignItems: 'center',
    },
    progressBar: {
        flex: 1,
        background: 'red',
        marginLeft: 8,
        height: 8,
    },
    hoverLogo: {
        height: 32,
        marginBottom: 16,
    },
    headerContainer: {
        alignItems: 'flex-end',
        width: '100%',
        justifyContent: 'center',
    },
    hoverText: {
        marginBottom: 8,
    },
    indent: {
        marginLeft: 24,
    },
    headerRow: {
        justifyContent: 'space-between',
        alignItems: 'flex-end',
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
    },
};

export default Experience;
